import React, { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import Lightbox from "yet-another-react-lightbox";

const defaultBreakpoints = {
    0: { slidesPerView: 1 },
    576: { slidesPerView: 2 },
    768: { slidesPerView: 3 },
    992: { slidesPerView: 4 }
};

function getSlidesPerView(breakpoints) {
    const sorted = Object.entries(breakpoints)
        .map(([k, v]) => [parseInt(k, 10), v.slidesPerView])
        .sort((a, b) => a[0] - b[0]);

    let value = sorted[0][1];
    for (const [bp, spv] of sorted) {
        if (window.innerWidth >= bp) value = spv;
        else break;
    }
    return value;
}


function Slider({
    items = [],
    title,
    headingClass = "container",
    sliderWrapperClass = "project-slider-wrapper",
    sliderClass = "project-slider",
    slideClass = "project-slide",
    thumbKey = "thumb",
    fullKey = "full",
    breakpoints = defaultBreakpoints,
    enableLightbox = true,
    LightboxComponent = Lightbox,
    lightboxProps = { className: 'light-box' },
    getLightboxSlides,
    onImageClick,
}) {
    const swiperRef = useRef(null);
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [currentSlidesPerView, setCurrentSlidesPerView] = useState(getSlidesPerView(breakpoints));

    useEffect(() => {
        const handleResize = () => setCurrentSlidesPerView(getSlidesPerView(breakpoints));
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, [breakpoints]);

    const slidesForLightbox = getLightboxSlides
        ? getLightboxSlides(items)
        : items.map((item) => ({ src: item[fullKey], alt: item.alt }));

    const handleImageClick = (i, item) => {
        if (typeof onImageClick === "function") onImageClick(item, i);
        if (enableLightbox) {
            setOpen(true);
            setIndex(i);
        }
    };

    const showArrows = items.length > currentSlidesPerView;

    return (
        <div className="block relative home-project">
            {title && (
                <div className={headingClass} data-aos="fade-up">
                    <div className="page-title mb-4">{title}</div>
                </div>
            )}

            <div className={sliderWrapperClass} style={{ position: "relative" }}>
                <Swiper
                    loop
                    modules={[Navigation]}
                    spaceBetween={2}
                    breakpoints={breakpoints}
                    onSwiper={swiper => { swiperRef.current = swiper; }}
                    className={sliderClass}
                >
                    {items.map((item, i) => (
                        <SwiperSlide key={i}>
                            <div
                                className={slideClass}
                                onClick={() => handleImageClick(i, item)}
                                style={enableLightbox || onImageClick ? { cursor: "zoom-in" } : { cursor: "default" }}
                            >
                                <img
                                    src={item[thumbKey]}
                                    alt={item.alt || `${title}-thumb-${i}`}
                                    loading="lazy"
                                />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                {/* Custom Navigation */}
                {showArrows && (
                    <div className="plans-milestone-arrows m-3">
                        <button className="arrow-btn" onClick={() => swiperRef.current && swiperRef.current.slidePrev()} aria-label="Önceki">
                            <i className="fa fa-chevron-left" />
                        </button>
                        <button className="arrow-btn" onClick={() => swiperRef.current && swiperRef.current.slideNext()} aria-label="Sonraki">
                            <i className="fa fa-chevron-right" />
                        </button>
                    </div>
                )}
            </div>

            {enableLightbox && LightboxComponent && (
                <LightboxComponent
                    open={open}
                    close={() => setOpen(false)}
                    index={index}
                    slides={slidesForLightbox}
                    {...lightboxProps}
                />
            )}
        </div>
    );
}
export default Slider;
